import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaginationService } from '../PaginationService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { Router } from '@angular/router';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';

@Component({
  selector: 'app-feedback-template',
  templateUrl: './feedback-template.component.html',
  styleUrls: ['./feedback-template.component.scss']
})
export class FeedbackTemplateComponent implements OnInit {
  isProcessing = false;
  feedbackTemplateList: any = [];
  feedbackTemplateData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";
  pdfPageSizes: any = [];
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;



  columnList: any;
  visibleAddOrEditFeedbackTemplatePopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteFeedbackTemplatePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditFeedbackTemplatePopup', { static: true }) addOrEditFeedbackTemplatePopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;


  addOrEditFeedbackTemplatePopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteFeedbackTemplatePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };


  isAdenabled: boolean = false;

  constructor(public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, private readonly authService: MsalService
    , public message: messageService, public router: Router, private readonly elem: ElementRef) {

  }

  refreshGridData() {
    this.getCallMethod();
  }
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  ngOnInit(): void {
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.columnList = [
      { column: "Template Name", width: "200px", key: "templateName" },
      { column: "Template Description", width: "240px", key: "templateDescription" },
      { column: "Score Formula", width: "200px", key: "scoreFormula" },
      { column: "Is Active?", width: "140px", key: "isActive" },
      { column: "Created On", width: "120px", key: "createdOn" },
      { column: "Created By", width: "140px", key: "createdByUser" },
      { column: "Updated On", width: "120px", key: "updatedOn" },
      { column: "Updated By", width: "140px", key: "updatedByUser" },
      { column: "Update Reason", width: "140px", key: "updateReason" }
    ];
    this.getCallMethod();
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
  }



  getCallMethod() {
    this.appService.getFeedbackTemplatesList().subscribe((data: any) => {
      this.isProcessing = false;
      this.feedbackTemplateList = data;
      this.collectionSize = this.feedbackTemplateList.length;

      this.setPage(1, 0);
      this.pager.totalPages = undefined;
    })
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.feedbackTemplateList.length, page, this.perPage, targetpage);
    this.pagedItems = this.feedbackTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  feedbackTemplateListTemp: any = [];
  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.feedbackTemplateListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.feedbackTemplateListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.feedbackTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.feedbackTemplateListTemp = this.feedbackTemplateList;
      this.pager = this.paginationService.getPager(this.feedbackTemplateListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.feedbackTemplateListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.feedbackTemplateList == undefined) {
        return this.feedbackTemplateList;
      }
      if (!this.feedbackTemplateList.length) {
        return this.feedbackTemplateList;
      }
      if (filter) {
        this.feedbackTemplateListTemp = this.feedbackTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.feedbackTemplateListTemp = this.feedbackTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.feedbackTemplateList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const template of this.feedbackTemplateList) {
      template.childCheckBoxs = isChecked;
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {

    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }


  openAddPopup() {
    this.feedbackTemplateData = {};
    this.feedbackTemplateData.templateName = "";
    this.feedbackTemplateData.templateDescription = "";
    this.feedbackTemplateData.scoreFormula = "";
    this.feedbackTemplateData.isActive1 = true;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Feedback Template";
    this.visibleAddOrEditFeedbackTemplatePopup = this.dialog.open(this.addOrEditFeedbackTemplatePopup, this.addOrEditFeedbackTemplatePopupConfig);
  }

  previousData: any = {};
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.title = "Update Feedback Template"
    this.appService.getFeedbackTemplateById(editRowData.templateId).subscribe((response: any) => {
      this.feedbackTemplateData = response[0];
      this.message.breadcrumbData.thirdLevel = "Feedback Template (" + this.feedbackTemplateData.templateName + ")";
      this.router.navigate(['/dashboard/feedbackTemplateDetail'], {
        state: {
          feedbackTemplateData: this.feedbackTemplateData
        }
      });
    })
  }
  cancelAddAndEditFunction() {
    this.visibleAddOrEditFeedbackTemplatePopup.close();
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnList.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(list: any) {
    let templateName = list.target.innerText.trim();
    this.message.masterDetails = this.feedbackTemplateList.filter((x: any) => x.TEMPLATE_NAME.trim() === templateName);

  }

  goToDetailPage(editRowData: any, event: any) {
    event.preventDefault();
    this.isProcessing = true;
    this.appService.getFeedbackTemplateById(editRowData.templateId).subscribe((response: any) => {
      this.feedbackTemplateData = response[0];
      this.message.breadcrumbData.thirdLevel = "Feedback (" + this.feedbackTemplateData.templateName + ")";
      this.router.navigate(['/dashboard/feedbackTemplateDetail'], {
        state: {
          feedbackTemplateData: this.feedbackTemplateData
        }
      });
    })
  }

  applyFilter3(columnKey: string, event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filterValue === '') {
      // Reset to original list if search is cleared
      this.setPage(1, 0);
    } else {
      this.pagedItems = this.feedbackTemplateList.filter((item: any) => {
        const cellValue = item[columnKey];
        if (cellValue == null) return false;
        if (columnKey === 'createdOn' || columnKey === 'updatedOn') {
          const dateStr = new Date(cellValue).toLocaleDateString().toLowerCase();
          return dateStr.includes(filterValue);
        }
        return cellValue.toString().toLowerCase().includes(filterValue);
      });
      this.collectionSize = this.pagedItems.length;

    }
  }
  templateNameCss: any;
  templateNameReqdMsg: any;
  fieldValidation() {
    this.templateNameCss = document.getElementById('templateName') as HTMLInputElement;
    this.templateNameReqdMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;

    if (this.feedbackTemplateData.templateName == "") {
      this.templateNameCss.style.border = '1px solid red';
      this.templateNameReqdMsg.style.display = 'block';
    } else {
      this.templateNameCss.style.border = 'none';
      this.templateNameReqdMsg.style.display = 'none';
    }
  }
  focusEmpty() {
    console.log();
  }
  addAndEditFunction(feedbackData: any) {
    this.isProcessing = true;
    if (feedbackData.templateName == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == "ADD") {

        this.feedbackTemplateData.isActive = feedbackData.isActive1 ? "Y" : "N";
        this.appService.createFeedbackTemplate(this.feedbackTemplateData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.visibleAddOrEditFeedbackTemplatePopup.close();
              this.getCallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        this.feedbackTemplateData.isActive = feedbackData.isActive1 ? "Y" : "N";
        delete this.feedbackTemplateData['createdOn'];
        delete this.feedbackTemplateData['updatedOn'];
        this.appService.updateFeedbackTemplate(this.feedbackTemplateData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.visibleAddOrEditFeedbackTemplatePopup.close();
              this.getCallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }



  }


  openDeletePopup(feedback: any) {
    this.feedbackTemplateData = feedback;
    this.title = "Delete Feedback Template";
    if (this.feedbackTemplateData.deleteReason != undefined) {
      this.feedbackTemplateData.deleteReason = '';
    }
    this.visibleDeleteFeedbackTemplatePopup = this.dialog.open(this.deletePopup, this.deleteFeedbackTemplatePopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteFeedbackTemplatePopup.close();
  }
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {

      delete this.feedbackTemplateData['createdOn'];
      delete this.feedbackTemplateData['updatedOn'];
      this.appService.deleteFeedbackTemplate(this.feedbackTemplateData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.visibleDeleteFeedbackTemplatePopup.close();
          this.isProcessing = true;
          this.getCallMethod();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, feedback: any) {
    this.message.tableOrView_Name = "ONEQMS_FEEDBACK_TEMPLATES_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,TEMPLATE_NAME,TEMPLATE_DESCRIPTION,SCORE_FORMULA,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Template Name,Template Description,Score Formula,Is Active?,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? "" : " AND TEMPLATE_ID = " + feedback.templateId;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Template Name,Template Description,Score Formula,Is Active?,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? "" : " WHERE TEMPLATE_ID = " + feedback.templateId;
    this.message.report_And_Popup_Name = "FeedBack Template Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(feedback);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "ONEQMS_FEEDBACK_TEMPLATES_VW";
    this.excelPdf.columnList_DB = "TEMPLATE_NAME,TEMPLATE_DESCRIPTION,SCORE_FORMULA,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Template Name,Template Description,Score Formula,Is Active?,Created On,Created By,Updated On,Updated By,Update Reason";
    this.excelPdf.whereClause_Report = '';
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'FeedBack Template Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

}
